module.exports = __webpack_public_path__ + "img/chip.5fb7062d.svg";